/* eslint-disable import/no-extraneous-dependencies, react/require-default-props */
import PropTypes from 'prop-types'
import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import defaults from 'react-images/lib/theme'
import deepMerge from 'react-images/lib/utils/deepMerge'
import Icon from 'react-images/lib/components/Icon'

const defaultStyles = {
  arrow: {
    background: 'none',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    outline: 'none',
    padding: 10,
    position: 'absolute',
    top: '50%',
    WebkitTouchCallout: 'none',
    userSelect: 'none',
  },
  arrow__size__medium: {
    height: defaults.arrow.height,
    marginTop: defaults.arrow.height / -2,
    width: 40,
    '@media (min-width: 768px)': {
      width: 70,
    },
  },
  arrow__size__small: {
    height: defaults.thumbnail.size,
    marginTop: defaults.thumbnail.size / -2,
    width: 30,
    '@media (min-width: 500px)': {
      width: 40,
    },
  },
  arrow__direction__right: {
    right: defaults.container.gutter.horizontal,
  },
  arrow__direction__left: {
    left: defaults.container.gutter.horizontal,
  },
}

export default function Arrow({
  direction,
  icon,
  onClick,
  size = 'medium',
  ...props
}) {
  const classes = StyleSheet.create(deepMerge(defaultStyles, {}))

  return (
    <button
      type="button"
      className={css(
        classes.arrow,
        classes[`arrow__direction__${direction}`],
        size && classes[`arrow__size__${size}`]
      )}
      onClick={onClick}
      onTouchEnd={onClick}
      {...props}
    >
      <Icon fill={defaults.arrow.fill} type={icon} />
    </button>
  )
}

Arrow.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']),
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['medium', 'small']),
}
